import { doc, updateDoc } from "firebase/firestore";
import { db } from "../Firebase";
import { useState } from "react";
import StatusBadge from "./StatusBadge";

export default function StatusSelect({ leadId, currentStatus }) {
  const [status, setStatus] = useState(currentStatus);
  const [saving, setSaving] = useState(false);

  const handleChange = async (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    setSaving(true);

    await updateDoc(doc(db, "leads", leadId), {
      status: newStatus,
      updatedAt: new Date(),
    });

    setSaving(false);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <select
        value={status}
        onChange={handleChange}
        disabled={saving}
        className={`status-select status-${status}`}
      >
        <option value="new">New</option>
        <option value="contacted">Contacted</option>
        <option value="inspection_scheduled">Inspection Scheduled</option>
        <option value="est-sent">Estimate Sent</option>
        <option value="inv-sent">Invoice Sent</option>
        <option value="closed">Closed</option>
      </select>
    </div>
  );
}